import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, SetupData } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: {
      totalCount: 0,
    },
  },
};

const setupSlice = createSlice({
  name: 'setup',
  initialState,
  reducers: {
    setSetupData(state: initState, action: PayloadAction<{ list: SetupData }>) {
      state.list = action.payload.list;
    },
  },
});

export const { setSetupData } = setupSlice.actions;

export default setupSlice.reducer;
